import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IconModule } from '../icon/icon.module';
import { PreloaderModule } from '../preloader/preloader.module';
import { AdvancedTypeaheadComponent } from './advanced-typeahead.component';

@NgModule({
  declarations: [AdvancedTypeaheadComponent],
  imports: [CommonModule, IconModule, ReactiveFormsModule, PreloaderModule],
  exports: [AdvancedTypeaheadComponent],
})
export class AdvancedTypeaheadModule {}
